import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import { Page } from './common/styles';
import SiteMap from './common/site-map';
import Footer from './common/footer';
import Contact from './common/contact';
import JoinForm from './common/join-form';

export default function OurStory(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
    light: false,
  };

  return (
    <ThemeProvider theme={state}>
      <Page>
        <Contact formId="contact_us" formName="contact_us" formTitle="Contact Us" />
        {!common.isUserSignedIn && <JoinForm />}
        <SiteMap />
        <Footer />
      </Page>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
OurStory.propTypes = {
  logo: PropTypes.string.isRequired,
  hero: PropTypes.string.isRequired,
  heroPortrait: PropTypes.string.isRequired,
  ourStory: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
};
/* eslint-enable react/no-unused-prop-types */
